/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAccount } from '../models/SourceAccount';

export class ReconnectSourceAccountResponse {
  'sourceAccount': SourceAccount;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sourceAccount",
      "baseName": "sourceAccount",
      "type": "SourceAccount",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ReconnectSourceAccountResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

